import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase, ValidationError, Void } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { AddProductEventRequest } from '../../productevents/addproductevent/addproductevent.request';

@Injectable({ providedIn: 'root' })
export class AddProductEventUseCase extends UseCase<AddProductEventRequest, Observable<Void>> {
	private _apiRequestService = inject(ApiRequestService);
	private _storeBaseUrl = inject<string>('STORE_BACKEND_URL' as never);
	private _createProductEventUrl = '/admin/addProductEvent';

	constructor(_logService: LogService, _http: HttpClient) {
		super(_logService, _http);
	}

	protected override validate(request: AddProductEventRequest): void {
		if (!request.productEventRegistrationList?.length) {
			throw new ValidationError('productEventRegistrationList is empty');
		}
	}

	protected override executeBusinessLogic(request: AddProductEventRequest | void): Observable<Void> | void {
		return this._apiRequestService.sendRequest<AddProductEventRequest, Void>(
			this._storeBaseUrl,
			request as AddProductEventRequest,
			true,
			this._createProductEventUrl,
			undefined,
			undefined,
			true
		);
	}
}
